import { render, staticRenderFns } from "./subscript.vue?vue&type=template&id=75da1cb4&"
import script from "./subscript.vue?vue&type=script&lang=js&"
export * from "./subscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports